import { render, staticRenderFns } from "./DeletePartner.vue?vue&type=template&id=965e4422&scoped=true&"
import script from "./DeletePartner.vue?vue&type=script&lang=ts&"
export * from "./DeletePartner.vue?vue&type=script&lang=ts&"
import style0 from "./DeletePartner.vue?vue&type=style&index=0&id=965e4422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965e4422",
  null
  
)

export default component.exports